import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <section className="p-card" style={{ maxWidth: 600 }}>
      <span className="p-eyebrow">Error 404</span>
      <h1>Page not found</h1>
      <p className="p-muted">The address does not match a page on the developer site.</p>
      <Link className="p-btn secondary" to="/">Back to the dashboard</Link>
    </section>
  );
}
